module.exports = __webpack_public_path__ + "KaTeX_Script-Regular.783bed39.ttf";